/**
 * Behavior for the cart drawer's "Add-ons" and "You may also like"
 * shelves: prev/next arrow scrolling, and "Add to cart" for items with
 * no variant to choose (items with real variants render a "View
 * options" link to the product page instead - see
 * cart-drawer-shelf-item.liquid).
 *
 * Uses delegated document-level click listeners so this works
 * regardless of when the drawer's markup is inserted (it's rendered
 * dynamically by the cart drawer's Vue component), without needing
 * per-instance script binding.
 */
(function () {
  function getTrack(wrapper) {
    return wrapper.querySelector('.cross-sells-products');
  }

  function updateCartDrawer(cart) {
    if (!window.wetheme) return;

    var pageContainer = document.getElementById('PageContainer');
    var cartAction = pageContainer ? pageContainer.getAttribute('data-cart-action') : null;

    if (cartAction === 'drawer') {
      window.wetheme.toggleRightDrawer('cart', true, { cart: cart });
    } else {
      window.wetheme.updateCartDrawer(cart);
    }
  }

  function addToCart(button) {
    if (button.disabled) return;

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;

    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (response) { return response.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (response) { return response.json(); })
      .then(function (cart) { updateCartDrawer(cart); })
      .catch(function (error) {
        console.error('Unable to add to cart:', error);
      })
      .finally(function () {
        button.disabled = false;
      });
  }

  document.addEventListener('click', function (event) {
    var arrowButton = event.target.closest('.cart-drawer-shelf__arrow');
    if (arrowButton) {
      var wrapper = arrowButton.closest('.cross-sells-wrapper');
      var track = wrapper && getTrack(wrapper);
      if (!track) return;

      var direction = parseInt(arrowButton.getAttribute('data-direction'), 10) || 1;
      var amount = Math.round(track.clientWidth * 0.8) || 220;

      track.scrollBy({ left: direction * amount, behavior: 'smooth' });
      return;
    }

    var addButton = event.target.closest('[data-cart-drawer-add]');
    if (addButton) {
      event.preventDefault();
      addToCart(addButton);
    }
  });
})();
